// extracted by mini-css-extract-plugin
export default {"uppercase":"uppercase__PW888","hidden":"hidden__sUXPn","delete-btn":"delete-btn__ryBAj","expanded-row":"expanded-row__QGGUL","innerapp-title":"innerapp-title__E88qp"};